export const environment = {
  name: 'Dev',
  production: false,
  apiUrl: 'https://api.development.fyndph.com',
  mapUrl: 'https://nominatim.openstreetmap.org',
  localIp: 'https://ipapi.co/json/',
  featureFlag: true,
  userPoolId: 'ap-southeast-2_6XhOD1C1U',
  userPoolClientId: '6iohmnm3tec3jb5992gd9h1erp',
  cognitoDomain: 'auth-fynd-dev.auth.ap-southeast-2.amazoncognito.com',
  supabaseUrl: 'https://ujmblgmxgguuwqvgnyee.supabase.co',
  supabaseAnonKey:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVqbWJsZ214Z2d1dXdxdmdueWVlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODEyMzgxMjgsImV4cCI6MjA5NjgxNDEyOH0.I50p_HuQzNNLqT7EyUEUYMlzKts4npz0YKxe1ExDOD8',
};
